import { filterableContentOf } from "../../utils/filterableContentOf";
import { multilingualArrayText } from "./index";

export default filterableContentOf(
  multilingualArrayText.name,
  multilingualArrayText.toReadableText!,
  "filterableMultilingualText"
);
